import { axiosSaamsInstance } from '.';

export const GetCredentialList = async (organisationId, payload) => {
  const url = `/userManagement/v1/organisations/${organisationId}/credentials/list`;
  return await axiosSaamsInstance({ method: 'Post', url: url, data: payload });
};

export const AddSingleCredential = async (organisationId, payload) => {
  const url = `/userManagement/v1/organisations/${organisationId}/credential/create`;
  return await axiosSaamsInstance({ method: 'Post', url: url, data: payload });
};

export const AddBulkCredentials = async (organisationId, payload) => {
  const url = `/userManagement/v1/organisations/${organisationId}/credentials/bulkCreate`;
  return await axiosSaamsInstance({ method: 'Post', url: url, data: payload });
};

export const GetBulkRequestStatus = async (organisationId, partnerId, requestId) => {
  const url = `/userManagement/v1/organisations/${organisationId}/requestStatus/${requestId}?partnerId=${partnerId}`;
  return await axiosSaamsInstance({ method: 'Get', url: url });
};

export const DeleteCredentials = async (organisationId, payload) => {
  const url = `/userManagement/v1/organisations/${organisationId}/deleteCredential`;
  return await axiosSaamsInstance({ method: 'Post', url: url, data: payload });
};

export const CredentialReportDownload = async (organisationId, payload) => {
  const url = `/userManagement/v1/organisations/${organisationId}/credentials/list/excel`;
  return await axiosSaamsInstance({ method: 'Post', url: url, data: payload, responseType: 'blob' });
};
